module.exports = __webpack_public_path__ + "img/introduce3.ffbe65bc.jpg";